import { IAppState } from '../common/state';

export function selectMarkedListItems(state: IAppState) {
  return state.results.markedList?.items || [];
}
